import { render, staticRenderFns } from "./DraftingTable.vue?vue&type=template&id=a9c63578&"
import script from "./DraftingTable.vue?vue&type=script&lang=ts&"
export * from "./DraftingTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports